import { useEffect } from 'react';

import { CircularProgress } from '@mui/material';

import LogoWebp from 'assets/images/logos/logo.webp';

import './LoadingSpin.scss';

interface ILoadingSpin {
  loading: boolean;
  loadingtext?: string;
}

const LoadingSpin = ({
  loading,
  loadingtext = '',
}: ILoadingSpin): JSX.Element => {
  useEffect(() => {
    if (loading) {
      document.body.classList.add('stop-scrolling');
    } else {
      document.body.classList.remove('stop-scrolling');
    }

    return () => {
      document.body.classList.remove('stop-scrolling');
    };
  }, [loading]);

  return (
    <>
      {loading && (
        <div className="loading_spin__container">
          <div className="loading_spin_logo">
            <img
              src={LogoWebp}
              alt="TouchTask logo"
              style={{ height: '67px', marginBottom: '20px' }}
            />
            <p>Tecnología uniendo</p>
            <p>personas y empresas.</p>
          </div>
          <CircularProgress />
          {loadingtext && (
            <div
              className="mt-30 text__main"
              style={{ textAlign: 'center', maxWidth: '200px' }}
            >
              {loadingtext}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default LoadingSpin;
